import QueryString from 'qs'
import { REACT_APP_BSO_USER_ID, USER_CATEGORY_KEY, USER_ID_KEY } from '../../../../urls'

export const unitsPopulate = [
    'Documents',
    'User',
    'Marketing',
    'Property',
    'Viewings',
    'Offers',
    'Advertises.Unit.id',
    'Advertises.User.id',
    "Landlords"
]

export const getQueryUnits = (): string => {
    const userID = window.localStorage.getItem(USER_ID_KEY)
    const userCATEGORY = window.localStorage.getItem(USER_CATEGORY_KEY)
    let unitsQueryObject = {}
    const filters = {
  $and: [
    { User: { id: { $notNull: true } } },
    { ManagedBy: { $notNull: true } },
   // { Statuses: { $notNull: true, $ne: [] } },
  ]
}

         if (Number(userID) === Number(REACT_APP_BSO_USER_ID)) {
        unitsQueryObject = {
            filters,
            populate: {
                KeysBookings: '*',
                Marketing: '*',
                User: {
                    fields: ['id', 'DeviceToken']
                },
                Documents: {
                    populate: {
                        Type: '*'
                    }
                },
         
                Property: '*' ,
           
                Viewings: {
                    populate: {
                        User: {
                            fields: ['id']
                        }
                    }
                },
      
                Offers: {
                    populate: {
                        Type: '*',
                        User: {
                            fields: ['id']
                        }
                    }
                },
                Advertises: {
                    populate: {
                        User: {
                            fields: ['id']
                        },
                        Unit: {
                            fields: ['id']
                        }
                    }
                },
                Landlords: {
                    populate: {
                        Landlord: {
                            populate: [
                                'Type',
                                'ContactInfo',
                                'Documents',
                                'PowerOfAttorney'
                            ]
                        },
                        Representatives: {
                            populate: [
                                'Documents',
                                'ContactInfo'
                            ]
                        }
                    }
                },
                DisabledTimes: '*',
            }
        }
    }
    const unitsQuery = QueryString.stringify(unitsQueryObject, { encode: false })

    return unitsQuery
}
